var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66 23.15V19.31H9.79C10.71 19.31 11.4 19.07 11.86 18.59C12.32 18.11 12.55 17.43 12.55 16.55C12.55 15.67 12.32 15 11.86 14.54C11.4 14.06 10.71 13.82 9.79 13.82H4.66V10.85H9.55C11.07 10.85 12.42 11.04 13.6 11.42C14.78 11.78 15.71 12.37 16.39 13.19C17.07 14.01 17.41 15.12 17.41 16.52V16.94C17.41 18.24 17.11 19.36 16.51 20.3C15.91 21.22 15.03 21.93 13.87 22.43C12.71 22.91 11.27 23.15 9.55 23.15H4.66ZM0.46 23.15V0.919998H5.26V23.15H0.46ZM4.66 13.04V10.1H8.98C9.92 10.1 10.6 9.86 11.02 9.38C11.44 8.9 11.65 8.26 11.65 7.46C11.65 6.62 11.44 5.96 11.02 5.48C10.6 5 9.92 4.76 8.98 4.76H4.66V0.919998H8.68C11.2 0.919998 13.13 1.45 14.47 2.51C15.83 3.57 16.51 5.08 16.51 7.04V7.49C16.51 8.85 16.16 9.94 15.46 10.76C14.78 11.58 13.85 12.17 12.67 12.53C11.51 12.87 10.18 13.04 8.68 13.04H4.66Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.df3f34a53f1da224ecf4eafb3a2ec1a6.svg";
export { ForwardRef as ReactComponent };